import store from '../../../core/store';

export const readUserWeekView = ({ user_id, start_date, end_date }) => {
  const query = [`start_date=${encodeURIComponent(start_date)}`];

  if (end_date) {
    query.push(`end_date=${encodeURIComponent(end_date)}`);
  }

  query.push(`user_id=${encodeURIComponent(user_id)}`);

  return store.dispatch({
    action: 'table.timesheet_entries/READ_USER_WEEK_VIEW',
    method: 'GET',
    endpoint: `/user_week_view?${query.join('&')}`,
    preloaded: false,
  });
};

export const readUserWeekViewTimeOff = ({ user_id, start_date, end_date }) => {
  const query = [`start_date=${encodeURIComponent(start_date)}`];

  if (end_date) {
    query.push(`end_date=${encodeURIComponent(end_date)}`);
  }

  query.push(`user_id=${encodeURIComponent(user_id)}`);

  return store.dispatch({
    action: 'table.timesheet_entries/READ_USER_WEEK_VIEW_TIME_OFF',
    method: 'GET',
    endpoint: `/user_week_view/time_off?${query.join('&')}`,
    preloaded: false,
  });
};

export const readUserWeekViewStatistics = ({
  user_id,
  start_date,
  end_date,
}) => {
  const query = [
    `user_id=${encodeURIComponent(user_id)}`,
    `start_date=${encodeURIComponent(start_date)}`,
  ];

  if (end_date) {
    query.push(`end_date=${encodeURIComponent(end_date)}`);
  }

  return store.dispatch({
    action: 'table.timesheet_entries/READ_USER_WEEK_VIEW_STATISTICS',
    method: 'GET',
    endpoint: `/user_week_view/statistics?${query.join('&')}`,
    preloaded: false,
  });
};

export const createUserWeekViewItem = (formData) =>
  store.dispatch({
    action: 'table.timesheet_entries/CREATE_USER_WEEK_VIEW_ITEM',
    method: 'POST',
    endpoint: '/user_week_view',
    data: formData,
    preloaded: false,
  });

export const deleteUserWeekViewItem = (id) =>
  store.dispatch({
    action: 'table.timesheet_entries/DELETE_USER_WEEK_VIEW_ITEM',
    method: 'DELETE',
    endpoint: `/user_week_view/${id}`,
    preloaded: false,
  });

export const copyPreviousWeekUserWeekView = (formData) =>
  store.dispatch({
    action: 'table.timesheet_entries/COPY_PREVIOUS_WEEK_USER_WEEK_VIEW',
    method: 'POST',
    endpoint: '/user_week_view/copy_previous_week',
    data: formData,
    preloaded: false,
  });
